/* eslint-disable no-redeclare */
import { z } from 'zod';

export const SessionId = z
  .string()
  .regex(/^[0-9]{14}\.[0-9a-f]{12}(\.nv)?$/, 'Invalid Healthcare session id');

export type SessionId = z.infer<typeof SessionId>;
